
// src/web/components/group-nav.jsx

import React from 'react'
import connect from '../../connects/home-groups-nav'
import NotificationBadge from 'react-notification-badge';
import {Effect} from 'react-notification-badge';
import {
  AppBar,
} from 'react-toolbox/lib/app_bar'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import {
  Navigation
} from 'react-toolbox/lib/navigation'
import Avatar from 'react-toolbox/lib/avatar'
import SearchDrawer from './search-drawer.jsx'
import noWrappedNavigationTheme from './themes/no-wrapped-navigation.css'
import appBarTheme from './themes/app-bar.css'
import Tooltip from 'react-toolbox/lib/tooltip'
import animation from './animation-css'

const TooltipIconButton = Tooltip(IconButton)

class HomeGroupsNav extends React.Component {
  componentDidMount() {
      document.title = this.props.notificationUnreadCount > 0 ? `(${this.props.notificationUnreadCount}) ${this.props.t('label:すべてのグループ')} - gamba!` : `${this.props.t('label:すべてのグループ')} - gamba!`     
  }
  UNSAFE_componentWillUpdate(nextProps) {
    //未読通知があるか判定
   if (this.props.notificationUnreadCount != nextProps.notificationUnreadCount)
     document.title = nextProps.notificationUnreadCount > 0 ? `(${nextProps.notificationUnreadCount}) ${this.props.t('label:すべてのグループ')} - gamba!` : `${this.props.t('label:すべてのグループ')} - gamba!`     
  }
  render() {
    const {
      t,
      ui,
      updateUI,
      sidebarDocked,
      onLeftIconClick,
      isPhone,
      notificationUnreadCount,
      showNotifications,
      showChatRooms,
      chatUnreadCount,
      blinkChatButton,
      openSearchDrawer,
      openDrawer,
    } = this.props

    return (
      <AppBar leftIcon={isPhone && 'menu' || ''}
            onLeftIconClick={onLeftIconClick}
            theme={appBarTheme}>
        <div style={{ marginRight: 'auto' }}>
          {!isPhone && (
            <div style={{ display: 'inline' }}>
              <Avatar icon="home" />
              &nbsp;
            </div>
          )}
          <b>{t('label:すべてのグループ')}</b>
        </div>
        <Navigation type='horizontal' theme={noWrappedNavigationTheme}>
          <NotificationBadge count={notificationUnreadCount}
              containerStyle={{ position: 'absolute', top: '10px', right: '50px'}}
              effect={Effect.SCALE}/>
          <NotificationBadge count={chatUnreadCount}
              containerStyle={{ position: 'absolute', top: '10px', right: '0px'}}
              effect={Effect.SCALE}/>

          <TooltipIconButton inverse
              tooltip={t('label:検索')}
              icon="search"
              onClick={openSearchDrawer}/>

          <TooltipIconButton inverse
              tooltip={t('label:新着の通知')}
              icon={'notifications'+(!notificationUnreadCount && '_none' || '')}
              onClick={showNotifications}>
          </TooltipIconButton>

          <TooltipIconButton inverse
              {...animation(blinkChatButton)}
              tooltip={t('label:チャット')}
              icon={'comment'}
              onClick={showChatRooms}>
          </TooltipIconButton>
          <SearchDrawer active={openDrawer} group={{group_id: 'home'}} onClose={openSearchDrawer} />
        </Navigation>
      </AppBar>
    )
  }
}

export const RawHomeGroupsNav = HomeGroupsNav
export default connect(HomeGroupsNav)



// WEBPACK FOOTER //
// ./src/web/components/home-groups-nav.jsx